import React from 'react'
import { Typography, useDimensions } from '@telavita-core/react-design-kit'

import {
  ProfessionalSchedules,
  PatientCancellations,
  AvailabilitySchedules,
  PatientsCare,
  ProfessionalSchedulesAverage,
  ProfessionalNPS
} from 'components/ProfessionalGraphicsDashboard'

import { Container, Header, CardsContainer, SectionSide } from './styles'
import { useSelector } from 'react-redux'

const PRODUCT_30_MINUTES = 'PRO01004'

interface AuthStateI {
  auth: {
    profileSelected: {
      products: Array<{
        appointments: Array<{
          active: boolean;
          plans: Array<{
            plan: {
              code: string;
            }
          }>
        }>
        product: {
          code: string;
        };
      }>
    }
  }
}

function renderElementsOnDesktop(isMobile: boolean, showAvailabilitySchedulesGraphics: boolean) {
  return (
    <>
      <SectionSide isMobile={isMobile}>
        <PatientsCare />
        {showAvailabilitySchedulesGraphics ? (
          <>
            <AvailabilitySchedules />
            <PatientCancellations />
          </>
        ) : (
          <>
            <PatientCancellations />
            <ProfessionalNPS />
          </>
        )}
      </SectionSide>

      <SectionSide isMobile={isMobile}>
        <ProfessionalSchedules />
        <ProfessionalSchedulesAverage />
        {showAvailabilitySchedulesGraphics ? <ProfessionalNPS /> : null}
      </SectionSide>
    </>
  )
}

function renderElementsOnMobile(isMobile: boolean, showAvailabilitySchedulesGraphics: boolean) {
  return (
    <SectionSide isMobile={isMobile}>
      <PatientsCare />
      <ProfessionalSchedules />
      {showAvailabilitySchedulesGraphics ? <AvailabilitySchedules /> : null}
      <ProfessionalSchedulesAverage />
      <ProfessionalNPS />
      <PatientCancellations />
    </SectionSide>
  )
}

export function ProfessionalGraphics(): JSX.Element {
  const { isMobile } = useDimensions()

  const products = useSelector((state: AuthStateI) => state.auth.profileSelected.products)
  const has30MinutesScheduleProduct = products.some(product => product.product.code === PRODUCT_30_MINUTES)

  return (
    <Container>
      <Header>
        <Typography
          variant={isMobile ? 'header4' : 'header2'}
          center={isMobile}
          inlineStyles={{
            width: '100%',
            color: '#2D2D2D',
          }}
        >
          Gráficos de acompanhamento
        </Typography>
      </Header>

      <CardsContainer>
        {isMobile
          ? renderElementsOnMobile(isMobile, !has30MinutesScheduleProduct)
          : renderElementsOnDesktop(isMobile, !has30MinutesScheduleProduct)
        }
      </CardsContainer>
    </Container>
  )
}